import { createAction } from '@reduxjs/toolkit';
import type { UIAppNotificationState } from './AppNotificationsSlice';

export const progressNotificationState = createAction<{
  NotificationID: string;
  state: UIAppNotificationState;
  /** Force state change even if it's backward progression (e.g., for error rollback) */
  force?: boolean;
}>('appNotifications/progressNotificationState');

export const archiveNotification = createAction<{
  NotificationID: string;
}>('appNotifications/archiveNotification');

export const archiveAllVisibleNotifications = createAction<{
  NotificationIDs: string[];
  BatchSize: number;
  IsRetry?: boolean; // If true, the failed notifications will be retried
}>('appNotifications/archiveAllVisibleNotifications');
